export const HelpEndPoint = 'https://documentation.iii.com/vega/patron/';

export enum HelpLinks {
  HOME_PATRON = 'Default.htm',
}
